import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import GatsbyImage from '../Image/GatsbyImage';
import limitWordCount from '../../utils/limitWordCount';
import {
  Container,
  Clickable,
  Thumbnail,
  Body,
  Details,
  Category,
} from '../../styles/Components/Cards/DownloadCard';

const DownloadCard = ({ component }) => {
  const { t } = useTranslation();

  return (
    <Container className="download-card">
      {/* Overlay link covering the card. It has no children, so without a
          label it reaches the a11y tree unnamed. Same pattern as PodcastsCard. */}
      <Clickable
        to={`/downloads/${component?.slug}`}
        aria-label={component?.title}
      />
      <Thumbnail>
        {component?.thumbnailImage && (
          <GatsbyImage
            src={component?.thumbnailImage.gatsbyImageData}
            alt={component?.thumbnailImage?.alt}
          />
        )}
      </Thumbnail>
      <Body>
        <Details>
          <Category>
            <h6 className="card_type">{t('Download')}</h6>
            <h6 className="card_category">{component?.downloadsType?.name}</h6>
          </Category>
          <h4 className="card_title">{component?.title}</h4>
          <p className="card_description">
            {limitWordCount(component?.description, 24, true)}
          </p>
        </Details>
      </Body>
    </Container>
  );
};

export default DownloadCard;
